const mapElement = document.getElementById("pj-map");
const latitude = "49.4801647776969";
const longitude = "-2.514798339304775";

mapboxgl.accessToken =
  "pk.eyJ1IjoiaGFtaWx0b25icm9va2UiLCJhIjoiY20zNjNxN24wMDFrcDJrc2VlbTBlMXBoZCJ9.mvqouFkAtbTolZkWlKnyAQ";
const map = new mapboxgl.Map({
  container: "pj-map",
  style: "mapbox://styles/mapbox/streets-v11",
  center: [longitude, latitude],
  zoom: 14,
});

const svgMarker = document.createElement("div");
svgMarker.innerHTML = `
  <svg width="42" height="64" viewBox="0 0 42 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M35.8,6.2c-3.74-3.8-8.95-6.2-14.75-6.2-.02,0-.03,0-.05,0v64h1.33c1.28-21.3,19.67-26.7,19.67-42.7,0-5.9-2.36-11.2-6.2-15.1Z" fill="#4eb7a7"/><path d="M28,14h-7V0s-.03,0-.05,0c-5.8,0-11.01,2.4-14.75,6.2C2.36,10.1,0,15.4,0,21.3c0,16,18.39,21.4,19.67,42.7h1.33V28h7v-14Z" fill="#15a2f2"/><path d="M35.8,6.2c-3.74-3.8-8.95-6.2-14.75-6.2S10.03,2.4,6.2,6.2C2.36,10.1,0,15.4,0,21.3c0,16,18.39,21.3,19.67,42.7h2.66c1.28-21.3,19.67-26.7,19.67-42.7,0-5.9-2.36-11.2-6.2-15.1ZM9.64,38.85C5.18,33.25,1.33,28.41,1.33,21.3c0-5.33,2.07-10.36,5.81-14.16C10.74,3.57,15.41,1.55,20.34,1.37v12.63h7.66v14h-7.66v30.81c-1.78-8.76-6.47-14.66-10.7-19.96ZM21.66,58.83v-29.5h7.67V12.67h-7.67V1.36c4.99.16,9.65,2.18,13.19,5.77,3.75,3.81,5.82,8.84,5.82,14.17,0,7.12-3.86,11.98-8.33,17.61-4.21,5.3-8.9,11.21-10.68,19.92Z" fill="#000000"/>
  </svg>
`;
svgMarker.style.width = "42px";
svgMarker.style.height = "64px";

new mapboxgl.Marker(svgMarker, { anchor: "bottom" })
  .setLngLat([longitude, latitude])
  .addTo(map);
